var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-video-player" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _c("video-player", {
            ref: "player",
            attrs: { playsinline: true, options: _vm.playerOptions },
            on: {
              play: _vm.onPlay,
              pause: _vm.onPause,
              ended: _vm.onEnded,
              waiting: _vm.onWaiting,
              playing: _vm.onPlaying,
              loadeddata: _vm.onLoadeddata,
              timeupdate: _vm.onTimeupdate,
              canplay: _vm.onCanplay,
              canplaythrough: _vm.onCanplaythrough,
              statechanged: _vm.onStatechanged,
              ready: _vm.onReady,
            },
          }),
        ],
        1
      ),
      _c("div", {
        ref: "overlay",
        staticClass: "video-overlay",
        on: { click: _vm.onOverlayClick },
      }),
      _c("d-video-info"),
      _c(
        "w-ctrl-video",
        _vm._b(
          {
            on: {
              play: _vm.play,
              pause: _vm.pause,
              mute: _vm.mute,
              unmute: _vm.unmute,
              volume: _vm.setVolume,
              seek: _vm.seek,
            },
          },
          "w-ctrl-video",
          {
            player: _vm.player,
            playTime: _vm.playTime,
            playlist: _vm.playlist,
            index: _vm.index,
            paused: _vm.paused,
            muted: _vm.muted,
            volume: _vm.volume,
          },
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }